<template>
  <v-flex xs12 class="mb-4">
    <v-card>
      <v-card-title>
        <div class="flex-container-space-between">
          <page-title :routeProps="routeProps"></page-title>
          <div class="vertical-center-container text-xs-right">
            <v-tooltip
              left
              v-if="userAuthClass && $vuetify.breakpoint.smAndUp && ($store.state.user.userAuthClass.name=='Administrator' || $store.state.user.userAuthClass.name=='Account Manager')"
            >
              <v-btn
                slot="activator"
                icon
                large
                flat
                :color="$store.state.global.pages.docket.color"
                @click="importDialog = true"
              >
                <v-icon>attach_file</v-icon>
              </v-btn>Import Electronic Dockets
            </v-tooltip>
            <v-btn icon flat color="grey" class="mr-0" @click="drawer = !drawer">
              <v-icon>playlist_add</v-icon>
            </v-btn>
          </div>
        </div>
      </v-card-title>
      <v-container fluid>
        <v-layout>
          <v-flex xs12 sm6 lg3>
            <div class="flex-container-space-between">
              <v-autocomplete
                label="Choose filter"
                :items="filterCols"
                v-model="filterCol"
                prepend-icon="list"
                :clearable="true"
              ></v-autocomplete>
            </div>
          </v-flex>
          <v-flex xs12 sm6 md3>
            <v-text-field
              label="Filter by..."
              v-model="filterBy"
              prepend-icon="filter_list"
              :clearable="true"
              :hint="(this.filterCol == 'docket.date' || this.filterCol == 'docket.dateReceived') ? 'Date format must be YYYY-MM-DD' : ''"
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex xs12 sm6 lg3 class="pt-0">
            <div class="flex-container-space-between">
              <v-autocomplete
                label="Choose filter"
                :items="filterCols"
                v-model="filterCol2"
                prepend-icon="list"
                :clearable="true"
              ></v-autocomplete>
            </div>
          </v-flex>
          <v-flex xs12 sm6 md3 class="pt-0">
            <v-text-field
              label="Filter by..."
              v-model="filterBy2"
              prepend-icon="filter_list"
              :clearable="true"
              :hint="(this.filterCol == 'docket.date' || this.filterCol == 'docket.dateReceived') ? 'Date format must be YYYY-MM-DD' : ''"
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-container>
      <div class="mx-3 mb-5">
        <div class="flex-container-space-between">
          <div></div>

          <div class="text-xs-right grey--text body-2">
            <chip-display></chip-display>
          </div>
        </div>
        <card-divider-full></card-divider-full>
      </div>

      <v-card-actions></v-card-actions>
      <v-btn
        fab
        dark
        :color="routeProps.color"
        class="overlap-fab"
        @click="addDocketDialog = !addDocketDialog"
        v-if="$route.name == 'docket' && userAuthClass"
      >
        <v-icon dark>add</v-icon>
      </v-btn>
    </v-card>

    <v-dialog v-model="importDialog" lazy max-width="700px" v-if="userAuthClass">
      <import-dockets @close="importDialog = false" title="Import Electronic Dockets"></import-dockets>
    </v-dialog>

    <filter-drawer></filter-drawer>
    <docket-add-wrapper v-if="$route.name == 'docket'" v-model="addDocketDialog"></docket-add-wrapper>
  </v-flex>
</template>

<script>
import ImportDockets from "@/components/trips/actions/importDockets";
import Store from "@/store/computed/storeHelpers";
import DocketService from "@/services/requests/docketService";
import DocketAddWrapper from "@/components/addDocket/wrapper";
import RouteProps from "@/services/mixins/routeProps";

import { addDays } from "date-fns";
import FormatDates from "@/services/mixins/formatDates";
import FilterDrawer from "@/components/trips/filterDrawer";
import getProjects from "@/services/mixins/getMasterFiles/getProjects";
import ChipDisplay from "@/components/ui/chipDisplay";

export default {
  mixins: [RouteProps, FormatDates, getProjects],
  data() {
    return {
      addDocketDialog: false,
      filterCols: [
        {
          value: "docket.externalRef",
          text: "Reference"
        },
        {
          value: "GPSConfirmed",
          text: "GPS Status"
        },
        {
          value: "tippingDocketConfirmed",
          text: "Tipping Docket Status"
        },
        {
          value: "massDeclarationConfirmed",
          text: "Mass Status"
        },
        {
          value: "docket.site.name",
          text: "Site"
        },
        {
          value: "spoil.name",
          text: "Spoil"
        },
        {
          value: "tip.name",
          text: "Tip"
        },
        {
          value: "docket.vehicle.contractor.name",
          text: "Sub-contractor"
        },
        {
          value: "docket.vehicle.name",
          text: "Vehicle"
        },
        {
          value: "docket.vehicle.vehicleType.name",
          text: "Vehicle Type"
        },
        {
          value: "docket.driver.name",
          text: "Driver"
        },
        {
          value: "docket.date",
          text: "Docket Date"
        },
        {
          value: "docket.dateReceived",
          text: "Date Received"
        },
        {
          value: "docket.createdBy.name",
          text: "Entered By"
        },
        {
          value: "tippingDocketLineId",
          text: "Tipping Docket ID"
        },
        {
          value: "billId",
          text: "Bill ID"
        },
        {
          value: "rctiId",
          text: "RCTI ID"
        },
        {
          value: "wbDocketNumber",
          text: "W/B Docket #"
        }
      ],
      importDialog: false
    };
  },
  components: {
    DocketAddWrapper,
    FilterDrawer,
    ImportDockets,
    ChipDisplay
  },
  methods: {
    toggleView() {
      this.listView = !this.listView;
    },
    onDateRangeChange(val) {
      //console.log("date range changed" + val);
    },
    emptyFunc() {
      return;
    }
  },
  computed: {
    filterCol: Store.getSet({ store: "trips", prop: "filterCol" }),
    filterBy: Store.getSet({ store: "trips", prop: "filterBy" }),
    filterCol2: Store.getSet({ store: "trips", prop: "filterCol2" }),
    filterBy2: Store.getSet({ store: "trips", prop: "filterBy2" }),
    adjustmentData: Store.getSet({ store: "dockets", prop: "adjustmentData" }),
    drawer: Store.getSet({ store: "shared", prop: "drawer" })
  },
  watch: {
    adjustmentData(val) {
      if (!!val) {
        console.log(val);
        this.addDocketDialog = true;
      }
    }
  }
};
</script>

<style>
.overlap-fab {
  position: absolute !important;
  bottom: -33px;
  right: 20px;
}
</style>
